/* eslint-disable @typescript-eslint/no-explicit-any */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useContext, useState, useEffect } from 'react';
import { toUrl, get } from './util';
import { CacheContext } from './resource-cache';
import { constant } from 'lodash';
import { useAsync } from '../use-async';
export const resource = (basePath, Model, normalize) => ({
    createGet: (subpath = '') => ({
        convert: props => Object.assign(new Model(props), props),
        url: q => toUrl(basePath + subpath, q),
        normalize: normalize ? (res) => [normalize(res), res] : constant([]),
        urlFromData: normalize,
    }),
    createList: (subpath = '') => ({
        convert: (res) => res.map(x => Object.assign(new Model(x), x)),
        url: q => toUrl(basePath + subpath, q),
        normalize: normalize
            ? (res) => res.map(x => [normalize(x), x])
            : constant([]),
        urlFromData: normalize,
    }),
});
export const getResource = (resource, url, cache = new Map()) => __awaiter(this, void 0, void 0, function* () {
    const cacheHit = cache.get(url);
    if (cacheHit) {
        return resource.convert(cacheHit);
    }
    const value = cache.get(url) || (yield get(url));
    if (typeof value === 'undefined') {
        throw Error('Not found: ' + url);
    }
    cache.set(url, value);
    for (const [url, nData] of resource.normalize(value)) {
        cache.set(url, nData);
    }
    return resource.convert(value);
});
export const useResource = (resource, q) => {
    const cache = useContext(CacheContext);
    if (!cache) {
        throw Error('No cache found');
    }
    const url = resource.url(q);
    if (cache.offline) {
        const value = cache.get(url);
        if (!value) {
            throw Error(`Expected ${url} to be specified in resource cache. Found: ${Array.from(cache.keys())}`);
        }
        return { value };
    }
    const value = useAsync(() => __awaiter(this, void 0, void 0, function* () { return getResource(resource, url, cache); }), [resource, url, cache]);
    const [prev, setPrev] = useState();
    const acceptedValue = value || prev;
    useEffect(() => {
        if (acceptedValue) {
            setPrev(acceptedValue);
        }
    }, [acceptedValue]);
    return acceptedValue;
};
export const usePageResource = (resource) => {
    const cache = useContext(CacheContext);
    if (!cache) {
        throw Error('No cache found');
    }
    if (!cache.rootResourceUrl) {
        throw Error('usePageResource() must be called on a page with a root resource');
    }
    const res = cache.get(cache.rootResourceUrl);
    if (typeof res === 'undefined') {
        throw Error(`Expected ${cache.rootResourceUrl} to be cached`);
    }
    return resource.convert(res);
};
export const useCachedResource = (resource, q) => {
    const url = resource.url(q);
    const cache = useContext(CacheContext);
    if (!cache) {
        throw Error('No cache found');
    }
    const res = cache.get(url);
    if (typeof res === 'undefined') {
        throw Error(`Expected ${resource.url(q)} to be cached`);
    }
    return resource.convert(res);
};
//# sourceMappingURL=resource.js.map